export default __webpack_public_path__ + "static/media/arrow_upward.30eef0e3.svg";